import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Graph from "./Graph";

function Weather() {
  const [temperature, setTemperature] = useState();
  const [cityName, setCityName] = useState("sargodha");
  const [userCity, setUserCity] = useState(cityName);
  const [fetchUserCountery, setFetchUserCountry] = useState();
  const setInputValues = (e) => {
    setCityName(e.target.value);
  };

  const setCity = () => {
    setUserCity(cityName);
  };

  // this function will calculate time coming from api dt
  const calculateTime = (date) => {
    let hours = date.getHours();
    hours = hours === 0 ? "12:00 A.M" : String(hours);
    if (hours > 0 && hours < 12) {
      hours = String(hours) + "A.M";
    } else if (hours >= 12 && hours <= 23) {
      if (hours > 12 && hours <= 23) {
        hours = hours - 12;
      }

      hours = String(hours) + "P.M";
    }
    return hours;
  };

  // this function will fetch api and store data in state
  const fetchWeather = useCallback(async () => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thrusday",
      "Friday",
      "Saturday",
    ];
    let weatherByDay = {};
    try {
      const weather = await axios.get(
        `https://api.openweathermap.org/data/2.5/forecast?q=${userCity}&units=metric&appid=${process.env.REACT_APP_API_KEY}`
      );
      setFetchUserCountry(
        `${weather.data.city.name} ${weather.data.city.country}`
      );
      for (let i = 0; i < weather.data.list.length; ++i) {
        const date = new Date(
          weather.data.list[i].dt * 1000 - weather.data.city.timezone * 1000
        );
        // call function
        const hours = calculateTime(date);

        const currentDay = days[date.getDay()];
        const temp = weather.data.list[i].main.temp;
        const icon = weather.data.list[i].weather[0].icon;
        let obj = { temperature: temp, icon: icon, time: hours };
        if (currentDay in weatherByDay) {
          weatherByDay[currentDay].push(obj);
        } else {
          weatherByDay[currentDay] = [obj];
        }
      }
      setTemperature(weatherByDay);
    } catch (error) {
      if (error) {
        setTemperature();
      }
    }
  }, [userCity]);

  // use state hook used to call api fetch function
  useEffect(() => {
    fetchWeather();
  }, [fetchWeather]);

  const keys = temperature ? Object.keys(temperature) : [];
  const data = keys.map((obj) => {
    return {
      day: obj,
      temp: temperature[obj][0].temperature,
      icon: temperature[obj][0].icon,
    };
  });

  return (
    <>
      <div className="weather">
        <div className="requestBox">
          <input
            type="text"
            placeholder="Search city weathre"
            className="requestBox__search"
            onChange={setInputValues}
            value={cityName}
          />
          <button onClick={setCity} className="requestBox__btn">
            Search
          </button>
        </div>
        <div className="display">
          <p className="display__name">{fetchUserCountery}</p>
          <p className="display__temperature">
            {data.length > 0 ? data[0].temp : ""}&#176;
          </p>
        </div>

        <div className="temperatures">
          <ul className="temperatures__ul">
            {data.map((obj, key) => (
              <li key={key} className="temperatures__li">
                <span key={key} className="dailyTemperature__day">
                  {obj.day}
                </span>
                &nbsp;
                <span className="dailyTemperature__temp">{obj.temp}&#176;</span>
                <span>
                  <img
                    className="dailyTemperature__icon"
                    src={`http://openweathermap.org/img/w/${obj.icon}.png`}
                    alt="loading..."
                    width="30px"
                  />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Graph keys={keys} temp={temperature}></Graph>
    </>
  );
}

export default Weather;
